// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1E94b","productName":"Table_productName__2tyIp"};